var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer py-2 pl-3"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-md-12 text-lg-left text-md-left text-center"},[_c('span',{staticStyle:{"color":"#fff"}},[_vm._v("\n        "+_vm._s(new Date().getFullYear())+" © E-Coupon Management System\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00958a56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Footer.vue
// module id = null
// module chunks = 